export default {
	facebook: "https://www.facebook.com/Ustron/?fref=ts",
	youtube: "https://www.youtube.com/channel/UCp6ACbUsmomVI5_rzQPjAvQ",
	instagram: "https://www.instagram.com/miasto.ustron/",
	twitter: "#",
}